import React from 'react';
import { Picto } from '../../Picto';
import { FacebookLogo, InstagramLogo } from '../../Picto/charentes/Icons';
import { Website } from '../../Picto/Website';

interface IconListProps {
  title: string;
  phone?: string;
  email?: string;
  website?: string;
  facebook?: string;
  instagram?: string;
  googleMyBusiness?: string;
}

const GoogleMyBusinessIcon = () => (
  <svg
    className="GoogleMyBusinessIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 48 48"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.25 19.557H24V7.094h-8.142z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.858 7.094H9.142a2 2 0 0 0-1.941 1.52L4.5 19.557h9.75m9.75 0a4.875 4.875 0 0 1-9.75 0m0 0a4.875 4.875 0 0 1-9.75 0m29.25 0H24V7.094h8.142zM32.142 7.094h6.716a2 2 0 0 1 1.941 1.52L43.5 19.557h-9.75m-9.75 0a4.875 4.875 0 0 0 9.75 0m0 0a4.875 4.875 0 0 0 9.75 0"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.325 23.977v14.93a2 2 0 0 0 2 2h29.35a2 2 0 0 0 2-2v-14.93"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M33.5 33.569h3.956a3.977 3.977 0 0 1-3.88 4.072l-.077.001a4.073 4.073 0 1 1 0-8.147a4 4 0 0 1 2.02.536"
    />
  </svg>
);

const IconList = ({
  title,
  phone,
  email,
  website,
  facebook,
  instagram,
  googleMyBusiness,
}: IconListProps) => {
  return (
    <div className="icon--list">
      <p className="icon--list--title">{title}</p>
      <div className="icon--list--icons">
        {phone && (
          <a className="icon--phone" href={`tel:${phone}`} target="_blank" rel="noopener">
            <Picto iconKey={'phoneV2'} fill="black" />
          </a>
        )}
        {email && (
          <a className="icon--email" href={`mailto:${email}`} target="_blank" rel="noopener">
            <Picto iconKey={'envelopeV2'} fill="black" />
          </a>
        )}
        {website && (
          <a className="icon--website" href={website} target="_blank" rel="noopener">
            <Website fill="black" />
          </a>
        )}
        {facebook && (
          <a className="icon--facebook fiche-sit-facebook" href={facebook} target="_blank" rel="noopener">
            <FacebookLogo />
          </a>
        )}
        {instagram && (
          <a
            className="icon--instagram fiche-sit-instagram"
            href={instagram}
            target="_blank"
            rel="noopener"
          >
            <InstagramLogo />
          </a>
        )}
        {googleMyBusiness && (
          <a
            className="icon--googleMyBusiness fiche-sit-google-my-business"
            href={googleMyBusiness}
            target="_blank"
            rel="noopener"
          >
            <GoogleMyBusinessIcon />
          </a>
        )}
      </div>
    </div>
  );
};

export default IconList;
